export const INITIAL_LOAD = 'command.INITIAL_LOAD' as const;
export const AFTER_INITIAL_LOAD = 'command.AFTER_INITIAL_LOAD' as const;
